import { render, staticRenderFns } from "./stockout_former.vue?vue&type=template&id=525e54fa&"
import script from "./stockout_former.vue?vue&type=script&lang=js&"
export * from "./stockout_former.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports